import config from '@public-config'

export const checkIsServer = () => typeof window === 'undefined'

export const checkIsClient = () => typeof window !== 'undefined'

export const checkIsDev = () => config.popdailyEnv === 'development'
